export const Transitions = {
  timing: 'cubic-bezier(.62,.28,.23,.99)',
  all: 'all cubic-bezier(.62,.28,.23,.99) 0.2s',
};
export default Transitions;
